export default {
      id: "young-term-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#young-term",
      toString: function () {
        return this.url;
      }
    }